export default {
	"INITED": "inited",
	"LOADING": "loading",
	"UPLOADING": "uploading",
	"PAUSE": "pause",
	"STOP": "stop"
};